import {TaskRepetitionPreview} from '@hconnect/common/components/shiftEventDetails'
import {TaskRepetition} from '@hconnect/common/types'
import {tail} from 'lodash'
import {Moment} from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useProcessWorkOrderDueDatesPreview} from '../hooks'

type Props = {
  settings: TaskRepetition
  defaultStartDate?: Moment
  omitFirstOccurrence?: boolean
  plantId: string
  timezone: string
}

export const ProcessWorkOrderDueDatesPreviewLabel: React.FC<Props> = ({
  settings,
  defaultStartDate,
  omitFirstOccurrence,
  plantId,
  timezone
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const numberOfPreviewItems = 3
  const query = useProcessWorkOrderDueDatesPreview(plantId, settings, {
    dueDate: defaultStartDate as Moment,
    repetitionInfo: settings,
    requestedItemsCount: numberOfPreviewItems + (omitFirstOccurrence ? 2 : 1),
    createdEntitiesCount: 0
  })

  if (!query.data) {
    return <span>{t('recurringDialog.calculating')}</span>
  }

  if (query.error) {
    return <span>{t('error.general')}</span>
  }

  const dates = omitFirstOccurrence ? tail(query.data.previewDueDates) : query.data

  return (
    <TaskRepetitionPreview
      dates={dates as string[]}
      repetition={settings.repetition}
      timezone={timezone}
      weekDays={'weekDays' in settings ? settings.weekDays : undefined}
      numberOfPreviewItems={numberOfPreviewItems}
      namespace={FEATURE_NAMESPACE}
    />
  )
}
